import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardUserItemSummaryComponent } from './dashboard-user-item-summary.component';
import { AutocompleteModule } from '../autocomplete/autocomplete.module';
import { IonicModule } from '@ionic/angular';
import { PendingListSkeletonModule } from '../pending-list-skeleton/pending-list-skeleton.module';
import { RecommendationCardModule } from '../recommendation-card/recommendation-card.module';
import { QuoteCardModule } from '../quote-card/quote-card.module';
import { IconModule } from '../icon/icon.module';



@NgModule({
  declarations: [DashboardUserItemSummaryComponent],
  imports: [
    CommonModule,
    AutocompleteModule,
    PendingListSkeletonModule,
    IonicModule,
    QuoteCardModule,
    RecommendationCardModule,
    IconModule,
  ],
  exports: [DashboardUserItemSummaryComponent]
})
export class DashboardUserItemSummaryModule { }
